import { DOCUMENT, inject } from '@angular/core';
import { Store } from '@ngxs/store';

import { loadFont } from '@cosmos/util-font';
import { CustomerPortalPresentationQueries } from '@customer-portal/presentations/data-access-presentations';
import {
  DEFAULT_PRESENTATION_FONT,
  PRESENTATION_FONT_VARIANTS,
  PRESENTATION_FONT_WEIGHTS,
} from '@esp/presentations/page-modules/types-common';

export function injectTemplateFontHelper({
  document = inject(DOCUMENT),
  store = inject(Store),
}: {
  document?: Document;
  store?: Store;
} = {}) {
  return {
    preloadTemplateFont: async () => {
      const templatePrimaryFont = store.selectSnapshot(
        CustomerPortalPresentationQueries.getTemplateVariables
      )?.PrimaryFont;
      if (
        templatePrimaryFont &&
        templatePrimaryFont !== DEFAULT_PRESENTATION_FONT
      ) {
        try {
          await loadFont(
            document,
            templatePrimaryFont,
            PRESENTATION_FONT_VARIANTS
          );
          // Trigger font loading for all weights right away.
          PRESENTATION_FONT_WEIGHTS.map((weight) =>
            document.fonts.load(`${weight} 1rem "${templatePrimaryFont}"`)
          );
        } catch {
          // Ignore font loading errors
        }
      }
    },
  };
}
